import { Box } from '@mui/material';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { handlePhoneNumberAutocomplete } from './CountriesPhoneInput.utils';
import FormInputLabel from '../FormInput/FormInputLabel';
import { CountriesPhoneInputProps } from 'src/components/common/form/CountriesPhoneInput/CountriesPhoneInput.types';

function CountriesPhoneInput({
  variant = 'outlined',
  defaultCountry = 'mx',
  onlyCountries = ['mx', 'us', 'ca', 'co', 'pe', 'br', 've', 'ar', 'cl'],
  id,
  placeholder,
  onChange,
  label,
  size = 'medium',
  onBlur,
  onInputTrack,
  ...props
}: CountriesPhoneInputProps) {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }
    if (onInputTrack) {
      onInputTrack(e.target.name, e.target.value);
    }
  };

  const handleChange = (
    eventValue:
      | string
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (onChange) {
      const value =
        typeof eventValue === 'string' ? eventValue : eventValue.target.value;

      const handledPhoneNumber = handlePhoneNumberAutocomplete(value);
      onChange(handledPhoneNumber);
    }
  };

  return (
    <Box width="100%" mb={1}>
      {label && (
        <FormInputLabel label={label as string} required inputId={id} />
      )}
      <MuiPhoneNumber
        id={id}
        fullWidth
        defaultCountry={defaultCountry}
        onlyCountries={onlyCountries}
        variant={variant}
        disableAreaCodes
        countryCodeEditable={false}
        autoFormat={false}
        size={size}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        {...props}
      />
    </Box>
  );
}

export default CountriesPhoneInput;
